import { RpcEngine } from '../core/rpc.js'
import { METHODS } from '../core/events.js'
import type { CharacterInfo, PersonaInfo, CharacterSettings } from '../types/index.js'

export class CharacterModule {
  constructor(private rpc: RpcEngine) {}
  getInfo():     Promise<CharacterInfo>        { return this.rpc.call(METHODS.CHARACTER_GET_INFO) }
  getPersona():  Promise<PersonaInfo | null>   {
    return this.rpc.call<PersonaInfo | null | undefined>(METHODS.CHARACTER_GET_PERSONA).then(value => value ?? null)
  }
  getSettings(): Promise<CharacterSettings>    { return this.rpc.call(METHODS.CHARACTER_GET_SETTINGS) }
}
